export const FETCH_DB_TABLES = "FETCH_DB_TABLES";
export const FETCH_DB_TABLES_SUCCESS = "FETCH_DB_TABLES_SUCCESS";
export const FETCH_DB_TABLES_FAILED = "FETCH_DB_TABLES_FAILED";
